<template>
  <md-card>
    <md-card-content>
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-20 md-xsmall-size-100">
          <md-field>
            <label>Seleccione un almacén</label>
            <md-select
              :disabled="loading"
              v-model="value.warehouse"
              name="warehouse"
              id="warehouse"
            >
              <md-option
                v-for="item in catalogs.warehouses"
                :key="item.id"
                :value="item.id"
              >{{ item.name }}</md-option>
            </md-select>
          </md-field>
        </div>

        <div class="md-layout-item md-size-20 md-xsmall-size-100">
          <md-field class="md-toolbar-section-start md-layout-item">
            <label for="customerS">Seleccione un status</label>
            <md-select :disabled="loading" placeholder="Buscar por status" v-model="value.status">
              <md-option :value="0">Todos</md-option>
              <md-option :value="c.id" v-for="c in catalogs.status" :key="c.id">{{ c.name }}</md-option>
            </md-select>
          </md-field>
        </div>
        <div
          class="md-layout-item md-size-20 md-medium-size-50 md-small-size-50 md-xsmall-size-100"
        >
          <md-field>
            <label for="value.dateFrom">
              <md-icon>calendar_today</md-icon>
              <span v-show="!value.dateFrom">Desde</span>
            </label>
            <datetime
              :disabled="loading"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Desde"
              value-zone="America/Mexico_City"
              v-model="value.dateFrom"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-simple md-just-icon" @click="value.dateFrom = null">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>

        <div
          class="md-layout-item md-size-20 md-medium-size-50 md-small-size-50 md-xsmall-size-100"
        >
          <md-field>
            <label for="value.dateTo">
              <md-icon>calendar_today</md-icon>
              {{ value.dateTo ? "" : "Hasta" }}
            </label>
            <datetime
              :disabled="loading"
              input-style="border: none; outline:none; width: 100%"
              type="date"
              title="Hasta"
              value-zone="America/Mexico_City"
              v-model="value.dateTo"
              :phrases="{ ok: '', cancel: '' }"
              auto
            ></datetime>
            <md-button class="md-simple md-just-icon" @click="value.dateTo = null">
              <md-icon>close</md-icon>
            </md-button>
          </md-field>
        </div>
        <div class="md-layout-item md-size-20 md-xsmall-size-100">
          <md-field md-clearable class="md-toolbar-section-start md-layout-item">
            <md-input :disabled="loading" placeholder="Buscar por folio" v-model="value.search" />
          </md-field>
          <div class="ml-auto">
            <slot name="title-actions"></slot>
          </div>
        </div>
      </div>
    </md-card-content>
  </md-card>
</template>
<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    catalogs: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
};
</script>

<style lang="scss" scoped>
.vdatetime {
  margin-left: 2em;
  margin-top: 1.1em;
  width: 100%;
}

.date-label {
  top: -9px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/QuotesTracking/Filters.vue